import { useTranslation } from 'react-i18next'
import { Card, CardContent, Loading } from '@/components/v2/ui'
import { useSalesMetrics } from '@/hooks/useSalesMetrics'

interface ProductSalesCardProps {
  productId: string
}

export function ProductSalesCard({ productId }: ProductSalesCardProps) {
  const { t } = useTranslation()
  const { data, isLoading } = useSalesMetrics(productId)
  const metrics = data?.metrics

  return (
    <Card className="product-overview-sales">
      <CardContent className="p-7">
        <h3 className="mb-5 text-sm font-semibold text-neutral-900 dark:text-neutral-100">
          {t('products.overview.salesTitle')}
        </h3>
        {isLoading ? (
          <div className="flex justify-center py-4"><Loading size="sm" /></div>
        ) : (
          <div className="grid grid-cols-2 gap-4">
            <div className="rounded-lg bg-neutral-50 p-4 text-center dark:bg-neutral-800">
              <p className="text-xs text-neutral-500 dark:text-neutral-400">{t('products.overview.days30')}</p>
              <p className="mt-1 text-xl font-semibold text-neutral-900 dark:text-neutral-100">
                {metrics?.revenue_30d ?? '--'}
              </p>
              <p className="text-xs text-neutral-500 dark:text-neutral-400">{t('products.overview.revenue')}</p>
            </div>
            <div className="rounded-lg bg-neutral-50 p-4 text-center dark:bg-neutral-800">
              <p className="text-xs text-neutral-500 dark:text-neutral-400">{t('products.overview.days30')}</p>
              <p className="mt-1 text-xl font-semibold text-neutral-900 dark:text-neutral-100">
                {metrics?.quantity_30d != null ? metrics.quantity_30d.toLocaleString('de-DE') : '--'}
              </p>
              <p className="text-xs text-neutral-500 dark:text-neutral-400">{t('products.overview.units')}</p>
            </div>
          </div>
        )}
        {!isLoading && !metrics && (
          <p className="mt-4 text-xs text-neutral-400 dark:text-neutral-500">
            {t('products.overview.salesHint')}
          </p>
        )}
      </CardContent>
    </Card>
  )
}
